import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { BLOCK_GET_BLOCKS_AUTOCOMPLETE, BLOCK_GET_BLOCKS_MASTER, BLOCK_MODULE_NAMESPACE } from '../../../../store/block'
import { IUserDetails } from '../../../../models/user'
import { BlockParameter, IBlockParameter } from '../../../../models/block'
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store'
import { GenericDefaultSelectOption, IGenericDefaultSelectOption } from '../../../../models/generic'
import { CrudStatus, SearchEntities, SearchSortTypes, StateTypes, ActivityStatus } from '../../../../common/enums'
import { SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST_BYKEYS } from '../../../../store/search'
import { RECEPTION_LOADERS } from '../../../../store/reception/reception-types.store'
import { BM_SET_LOADER_STATE, BM_MODULE_NAMESPACE, BM_ACTION, BM_EDIT_BM } from '../../../../store/building-monitor/bm-types.store'
import { IApartmentListingViewModel, IApartmentParameter } from '../../../../models/apartment'
import { APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE, APARTMENT_GET_APPARTMENTS_MASTER, APARTMENT_MODULE_NAMESPACE, APARTMENT_SET_APPARTMENTS_MASTER } from '../../../../store/apartment'
import { BMMeetingParameter, IBMMeetingParameter } from '../../../../models/bm/bm-meeting.parameter'
import { AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE } from '../../../../store/authorization'
import { IBMDetailViewModel, IBMMeetingListingViewModel } from '../../../../models/bm'

const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const UPDATE_PARAM: string = 'update:param'

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const BMStore = namespace(BM_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)

@Component({
  components: {
    'bm-filters-loader': async () => import('../../loaders/bm-filters-loader/BMFiltersLoader.vue')
  }
})
class BMMeetingConditions extends Vue {
  @Prop({ default: () => new BMMeetingParameter(), type: [Object] })
  param: IBMMeetingParameter;

  dtTab: string
  dtTabs: string[]
  dtTemporaryDeclarant: any[] | null;
  dtActionOpen: boolean;

  constructor() {
    super()
    this.dtTab = null
    this.dtTabs = ['basicSearch']
    this.dtTemporaryDeclarant = []
    this.dtActionOpen = false
  }

  @UserStore.Getter userInfo: IUserDetails;
  @BlockStore.Getter blocks: any[];
  @SearchStore.Getter declarants: any[]
  @ApartmentStore.Getter apartments: IApartmentListingViewModel[]
  @BMStore.Getter bmCrudActionStatus: CrudStatus
  @BMStore.Getter bmSource: {
    activityStatus: ActivityStatus;
    detail: IBMDetailViewModel
  }

  @BlockStore.Action(BLOCK_GET_BLOCKS_MASTER)
  storeGetBlocks: (payload: { userInfo: IUserDetails, param?: any }) => Promise<any>
  @BlockStore.Action(BLOCK_GET_BLOCKS_AUTOCOMPLETE)
  storeGetBlocksAutocomplete: (param: IBlockParameter) => Promise<any>
  @SearchStore.Action(SEARCH_REQUEST_BYKEYS)
  storeGetDeclarants: (keys: SearchEntities[]) => Promise<any>;
  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_MASTER)
  storeGetApartments: (param: IApartmentParameter) => void
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (param: { blockId: number | number[], key: string }) => Promise<any>
  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;
  @BMStore.Action(BM_EDIT_BM)
  storeEditBM: () => void

  @BMStore.Mutation(BM_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void
  @ApartmentStore.Mutation(APARTMENT_SET_APPARTMENTS_MASTER)
  storeSetApartments
  @BMStore.Mutation(BM_ACTION)
  storeSetBMAction: (action: CrudStatus) => void

  get lblSetting() {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/ticket').default,
      ...require('@/locales/building-monitor').default
    }
  }
  get coDeclarants() {
    return this.dtTemporaryDeclarant.map(x => ({ value: x.id, text: x.fullname }))
  }
  get coSortTypes(): IGenericDefaultSelectOption<number>[] {
    return [SearchSortTypes.MoreRecent,
    SearchSortTypes.Older].map(val => new GenericDefaultSelectOption<number>(this.$t(this.lblSetting.lblSort[`lblSortType${val}`]).toString(), val))
  }
  get coStates(): IGenericDefaultSelectOption<string>[] {
    return [
      StateTypes.Open,
      StateTypes.Close
    ].map(type => new GenericDefaultSelectOption<string>(this.$t(this.lblSetting.lblState[type]).toString(), type))
  }

  get blockSearchParameter() {
    return {
      userInfo: this.userInfo,
      param: new BlockParameter()
    }
  }
  get sortValues(): number[] {
    return this.param.orderValues
  }
  set sortValues(val: number[]) {
    this.$emit(UPDATE_PARAM, { ...this.param, orderValues: val, $skip: 0 })
  }
  get fKTicketState(): string[] | number[] {
    return this.param.state
  }
  set fKTicketState(val: string[] | number[]) {
    this.$emit(UPDATE_PARAM, { ...this.param, state: val, $skip: 0 })
  }
  get bmArchived(): boolean {
    return this.param.is_archived
  }
  set bmArchived(val: boolean) {
    this.handleEmitParam({ is_archived: val })
  }

  mounted() {
    this.loadFiltersDatas()
  }

  created() {
    this.loadFunctionality()
  }

  loadFunctionality() {
    this.storeGetFunctionalities(BM_MODULE_NAMESPACE)
      .then(response => {
        if (this.$route.meta) {
          Object.keys(response).forEach(key => this.$route.meta[key] = true)
        }
      })
      .catch(error => console.log(error))
  }

  loadFiltersDatas() {
    /* this.storeGetBlocks(this.blockSearchParameter).catch(error => console.log(error)) */
    this.storeGetEntitySearch({ entity: [SearchEntities.Manager, SearchEntities.Salesperson], query: '' })
      .then(res => { this.dtTemporaryDeclarant = res })
  }

  handleEmitParam(param: any) {
    this.$emit(UPDATE_PARAM, { ...this.param, ...param, $skip: 0 })
  }
  handleRemoteFetch(key: string, cb: Function, loading: Function) {
    this.storeGetBlocksAutocomplete({ key })
      .then(res => {
        cb((res || []).map(x => ({ value: x.id, text: x.name })))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }

  handleGetDeclarants(key: string, cb: Function, loading: Function) {
    return this.storeGetEntitySearch({
      entity: [SearchEntities.Manager, SearchEntities.Salesperson], query: key, limit: 50
    })
      .then(res => {
        cb((res || []).map(x => ({ value: x.id, text: x.fullname })))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }
  setFilterLoaderState(value: boolean) {
    this.storeSetLoaderState({ key: RECEPTION_LOADERS.FILTERS, value })
  }

  handleEditBM() {
    this.dtActionOpen = false
    this.storeEditBM()
  }

  handleDeleteBM() {
    this.storeSetBMAction(CrudStatus.Delete)
    this.dtActionOpen = false
  }

  handleArchiveBM() {
    this.storeSetBMAction(CrudStatus.Archive)
    this.dtActionOpen = false
  }
}

export default BMMeetingConditions



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-meeting-conditions/index.ts